export default __webpack_public_path__ + "static/media/icon-20-icn-event-braking-3.2aa7e575.svg";